var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.admin.faq.index.title"),
            "icon-class": "mdi mdi-frequently-asked-questions"
          }
        },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-primary font-weight-bold",
                  attrs: { tag: "a", to: { name: "admin.faq.create" } }
                },
                [
                  _c("i", { staticClass: "mdi mdi-plus" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("pages.admin.faq.index.add_new_question")) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 grid-margin stretch-card" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("div", { staticClass: "form-group mt-4" }, [
                  _c("label", { attrs: { for: "preferred_language" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("pages.admin.faq.index.show_in_language")) +
                        ":"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showInLanguage,
                          expression: "showInLanguage"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "preferred_language" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.showInLanguage = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "en" } }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("pages.admin.faq.global.lang.en")) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "de" } }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("pages.admin.faq.global.lang.de")) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "lb" } }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("pages.admin.faq.global.lang.lb")) +
                            "\n                            "
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("static-loading-indicator-icon"),
                _vm._v(" "),
                !_vm.$store.getters.isExecutingRequest
                  ? _c("div", { staticClass: "table-responsive" }, [
                      _vm.questions.length
                        ? _c(
                            "table",
                            {
                              staticClass:
                                "table table-striped table-borderless"
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("pages.admin.faq.global.title")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("pages.admin.faq.global.text")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("pages.admin.faq.global.actions")
                                      )
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.questions, function(question) {
                                  return question.titles[_vm.showInLanguage] !==
                                    "null"
                                    ? _c("tr", { key: question.id }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              question.titles[
                                                _vm.showInLanguage
                                              ] || "/"
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              question.texts_short[
                                                _vm.showInLanguage
                                              ] || "/"
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn btn-warning btn-sm",
                                                attrs: {
                                                  tag: "button",
                                                  to: {
                                                    name: "admin.faq.edit",
                                                    params: {
                                                      question: question.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "mdi mdi-pencil"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-danger btn-sm",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteQuestion(
                                                      question.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "mdi mdi-trash-can"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e()
                                }),
                                0
                              )
                            ]
                          )
                        : _c("div", { staticClass: "alert alert-info" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.admin.faq.index.no_questions_found"
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }